import { interpretApplicant } from "./interpretation/applicantInterpreter";export function generateProgramExplanation({

  applicant,

  applicantInterpretation,

  programmeProfile,

  programProfile,

  fitLevel

}) {

  const profile =
    programmeProfile ||
    programProfile;

  const interpretation =
    applicantInterpretation ||
    (applicant
      ? interpretApplicant(applicant)
      : null);

  const narrative =
    profile
      ?.behaviouralNarrative
      ?.[fitLevel];

  if (!narrative) {

    console.warn(
      `No ${fitLevel} narrative found.`
    );

    return "";

  }

  if (typeof narrative === "function") {

    return narrative({

      applicantInterpretation:
        interpretation

    });

  }

  return [
    narrative.opening,
    narrative.strengths,
    narrative.programmeConnection,
    narrative.coaching,
    narrative.conclusion
  ]
    .filter(Boolean)
    .join("\n\n");

}